import React, { useEffect, useState, useRef } from "react";
import HeadingSecondary from "../components/ HeadingSecondary";
import IranLogo from "../assets/images/iran.png";
import CustomLetterPicker from "../components/CustomLetterPicker";
import transportationService from "../services/transportation.service";

// custom hooks
import { usePlaqueForm } from "../hooks/usePlaqueForm";
import { useLoginInfo } from "../hooks/useLoginInfo";
import { useActions } from "../hooks/useActions";
// end custom hooks
import { fixNumbers } from "../helper/helper";
import { useHistory } from "react-router-dom";
import DotLoading from "../components/DotLoading";

interface IinitialPlaqueState {
  firstNumber: {
    1: string;
    2: string;
  };
  letter: string;
  secondNumber: {
    1: string;
    2: string;
    3: string;
  };
  iranNumber: {
    1: string;
    2: string;
  };
}

const Transportation = () => {
  // const [height, setHeight] = useState(window.innerHeight);
  const [initHeight, setInitHeight] = useState(window.innerHeight);
  // const [keyboardIsProbablyOpen, setKeyboardIsProbablyOpen] = useState(false);

  useEffect(() => {
    setInitHeight(window.innerHeight);
  }, []);

  useEffect(() => {
    const updateWindowDimensions = () => {
      if (window.innerHeight === initHeight) {
        // setKeyboardIsProbablyOpen(false)
        showNavigation(true);
      } else if (window.innerHeight < initHeight - 80) {
        // setKeyboardIsProbablyOpen(true)
        showNavigation(false);
      }
      // const newHeight = window.innerHeight;
      // setHeight(newHeight);
      // console.log("updating height");
    };
    window.addEventListener("resize", updateWindowDimensions);
    return () => window.removeEventListener("resize", updateWindowDimensions);
    // eslint-disable-next-line
  }, []);

  const [showLetterPicker, setShowLetterPicker] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [inputLetterValue, setInputLetterValue] = useState("");
  const [errors, setErrors] = useState([]) as any;
  const [plaqueInfo, setPlaqueInfo] = useState({
    hasInfo: false,
    carHealthStatus: "",
    personHealthStatus: "",
    serviceType: "",
  });
  const { showNavigation } = useActions();

  // eslint-disable-next-line
  const { userLoginInfo, checkUserLogin } = useLoginInfo();
  const firstNumber1Ref = useRef<HTMLInputElement>(null);
  const firstNumber2Ref = useRef<HTMLInputElement>(null);
  const inputLetterRef = useRef<HTMLInputElement>(null);
  const secondNumber1Ref = useRef<HTMLInputElement>(null);
  const secondNumber2Ref = useRef<HTMLInputElement>(null);
  const secondNumber3Ref = useRef<HTMLInputElement>(null);
  const iranNumber1Ref = useRef<HTMLInputElement>(null);
  const iranNumber2Ref = useRef<HTMLInputElement>(null);

  // useEffect(() => {
  //   if (window.innerWidth <= 1200) {
  //     firstNumber1Ref.current?.focus();
  //   }
  // }, []);

  const onHandleFocus = () => {
    if (window.innerWidth <= 1200) {
      showNavigation(false);
    }
  };

  const onHandleBlur = () => {
    if (window.innerWidth <= 1200) {
      showNavigation(true);
    }
  };

  useEffect(() => {
    return () => {
      showNavigation(true);
    };
    // eslint-disable-next-line
  }, []);

  const status: any = {
    POSITIVE: {
      text: "مثبت",
      class: "u-red",
    },
    NEGATIVE: {
      text: "منفی",
      class: "u-green",
    },
    UNKNOWN: {
      text: "ثبت نشده",
      class: "u-grey",
    },
  };

  const activityStatus: any = {
    QUALIFIED: {
      text: "مجاز",
      class: "u-green",
    },
    DISQUALIFIED: {
      text: "غیر مجاز",
      class: "u-red",
    },
    CONDITIONAL_QUALIFIED: {
      text: "-",
      class: "u-grey",
    },
    NONE: {
      text: "-",
      class: "u-grey",
    },
  };
  // eslint-disable-next-line
  const history = useHistory();

  // defining the initial state for the form
  const initialPlaqueState: IinitialPlaqueState = {
    firstNumber: {
      1: "",
      2: "",
    },
    letter: "",
    secondNumber: {
      1: "",
      2: "",
      3: "",
    },
    iranNumber: {
      1: "",
      2: "",
    },
  };

  const isMounted = React.useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleShowLetterPicker = (e: any) => {
    setShowLetterPicker(true);
  };

  // eslint-disable-next-line
  useEffect(() => {
    const inputFeilds = document
      .querySelector(".plaque__number-holder")!
      .querySelectorAll("input");
    const validInputs = Array.from(inputFeilds).filter(
      (input) => input.value !== ""
    );
    if (validInputs.length === 8) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  });

  // getting the event handlers from our custom hook
  const {
    onIranNumber1,
    onUpIranNumber1,
    onIranNumber2,
    onUpIranNumber2,
    onSecondNumber1,
    onUpSecondNumber1,
    onSecondNumber2,
    onUpSecondNumber2,
    onSecondNumber3,
    onUpSecondNumber3,
    onLetterChange,
    onFirstNumber1,
    onFirstNumber2,
    onUpFirstNumber2,
    onSubmit,
    onPress,
    plaqueValues,
  } = usePlaqueForm(
    checkPlaqueCallback,
    initialPlaqueState,
    setErrors,
    firstNumber1Ref,
    firstNumber2Ref,
    inputLetterRef,
    secondNumber1Ref,
    secondNumber2Ref,
    secondNumber3Ref,
    iranNumber1Ref,
    iranNumber2Ref
  );

  // a submit function that will execute upon form submission
  async function checkPlaqueCallback() {
    // eslint-disable-next-line
    let getUserLoginInfo = JSON.parse(
      localStorage.getItem("userLoginInfo") as any
    ) as any;

    // send "values" to database
    const firstNumber = parseInt(
      fixNumbers(plaqueValues.firstNumber["1"] + plaqueValues.firstNumber["2"])
    );
    const secondNumber = parseInt(
      fixNumbers(
        plaqueValues.secondNumber["1"] +
          plaqueValues.secondNumber["2"] +
          plaqueValues.secondNumber["3"]
      )
    );
    const iranNumber = parseInt(
      fixNumbers(plaqueValues.iranNumber["1"] + plaqueValues.iranNumber["2"])
    );
    const letter = plaqueValues.letter;

    setIsLoading(true);

    try {
      const { data } = await transportationService.checkPlaque({
        lang: "fa",
        firstNumber,
        secondNumber,
        iranNumber,
        letter,
      });

      if (isMounted.current) {
        // setDisableButton(true);
        setErrors([]);
        setPlaqueInfo({
          hasInfo: true,
          carHealthStatus:
            data.carHealthStatus === null ? "" : data.carHealthStatus,
          personHealthStatus:
            data.personHealthStatus === null ? "" : data.personHealthStatus,
          serviceType: data.serviceType,
        });
      }
      // return false;
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 404) {
          setErrors([{ field: "plaque", message: "این پلاک ثبت نشده است." }]);
          setPlaqueInfo({ ...plaqueInfo, hasInfo: false });
          return false;
        }

        if (error.response.status === 400) {
          setErrors([{ field: "plaque", message: "این پلاک ثبت نشده است." }]);
          setPlaqueInfo({ ...plaqueInfo, hasInfo: false });
          return false;
        }
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="transportation">
      {/*<span>{keyboardIsProbablyOpen ? 'keyboard is open' : 'keyboard is close'}</span>*/}
      {/*<span>{height}</span>*/}
      {/*<span>{`init height ${initHeight}`}</span>*/}
      <CustomLetterPicker
        onLetterChange={onLetterChange}
        onShowLetterPicker={showLetterPicker}
        onSetShowLetterPicker={setShowLetterPicker}
        onSetInputLetterValue={setInputLetterValue}
      />
      <div className="u-margin-top-small-3-5 u-margin-bottom-small-2">
        <HeadingSecondary text="حمل و نقل عمومی" />
      </div>
      <div className="u-margin-top-small-2 u-margin-bottom-small-3">
        <h3 className="heading-tertiary">
          <span className="heading-tertiary--main">
            استعلام وضعیت سلامت رانندگان
          </span>
          <span className="heading-tertiary--sub">
            از طریق این بخش با ورود پلاک وسیله نقلیه امکان استعلام وضعیت سلامت
            رانندگان بخش حمل و نقل عمومی اعم از تمامی تاکسی ها تاکسی های
            اینترنتی، آژانس ها،سرویس های مدارس و اتوبوس های شرکت واحد را خواهید
            داشت.
          </span>
        </h3>
      </div>

      <div className="inquiry">
        <form action="" className="inquiry__plaque" onSubmit={onSubmit}>
          <div
            className={
              errors?.some((v: any) => v.field === "plaque")
                ? "plaque input-error"
                : "plaque"
            }
          >
            <div className="plaque__number-holder">
              <div className="plaque__number-holder--right">
                <input
                  onFocus={onHandleFocus}
                  onBlur={onHandleBlur}
                  type="text"
                  inputMode="numeric"
                  ref={iranNumber2Ref}
                  autoComplete="off"
                  name="iranNumber_2"
                  onChange={onIranNumber2}
                  onKeyPress={onPress}
                  onKeyUp={onUpIranNumber2}
                  className="plaque-entity"
                  maxLength={1}
                />
                <input
                  onFocus={onHandleFocus}
                  onBlur={onHandleBlur}
                  type="text"
                  inputMode="numeric"
                  ref={iranNumber1Ref}
                  autoComplete="off"
                  name="iranNumber_1"
                  onChange={onIranNumber1}
                  onKeyPress={onPress}
                  onKeyUp={onUpIranNumber1}
                  className="plaque-entity"
                  maxLength={1}
                />
              </div>
              <div className="plaque__number-holder--line">
                <span />
              </div>
              <div className="plaque__number-holder--middle">
                <input
                  onFocus={onHandleFocus}
                  onBlur={onHandleBlur}
                  type="text"
                  inputMode="numeric"
                  ref={secondNumber3Ref}
                  autoComplete="off"
                  onChange={onSecondNumber3}
                  onKeyUp={onUpSecondNumber3}
                  onKeyPress={onPress}
                  className="plaque-entity"
                  maxLength={1}
                />
                <input
                  onFocus={onHandleFocus}
                  onBlur={onHandleBlur}
                  type="text"
                  inputMode="numeric"
                  ref={secondNumber2Ref}
                  autoComplete="off"
                  onChange={onSecondNumber2}
                  onKeyUp={onUpSecondNumber2}
                  onKeyPress={onPress}
                  className="plaque-entity"
                  maxLength={1}
                />
                <input
                  onFocus={onHandleFocus}
                  onBlur={onHandleBlur}
                  type="text"
                  inputMode="numeric"
                  ref={secondNumber1Ref}
                  autoComplete="off"
                  onChange={onSecondNumber1}
                  onKeyUp={onUpSecondNumber1}
                  onKeyPress={onPress}
                  className="plaque-entity"
                  maxLength={1}
                />
              </div>
              <div className="plaque__number-holder--letter">
                <input
                  type="text"
                  ref={inputLetterRef}
                  autoComplete="off"
                  className="plaque-entity"
                  maxLength={1}
                  value={inputLetterValue}
                  onFocus={handleShowLetterPicker}
                  readOnly={true}
                />
              </div>
              <div className="plaque__number-holder--left">
                <input
                  onFocus={onHandleFocus}
                  onBlur={onHandleBlur}
                  type="text"
                  inputMode="numeric"
                  ref={firstNumber2Ref}
                  autoComplete="off"
                  onChange={onFirstNumber2}
                  onKeyUp={onUpFirstNumber2}
                  onKeyPress={onPress}
                  className="plaque-entity"
                  maxLength={1}
                />
                <input
                  onFocus={onHandleFocus}
                  onBlur={onHandleBlur}
                  type="text"
                  inputMode="numeric"
                  ref={firstNumber1Ref}
                  autoComplete="off"
                  onChange={onFirstNumber1}
                  onKeyPress={onPress}
                  maxLength={1}
                />
              </div>
            </div>
            <div className="plaque--logo">
              <div className="plaque--logo-holder">
                <span>
                  <img src={IranLogo} alt="" width={23} height={13} />
                </span>
                <span>I.R.</span>
                <span>IRAN</span>
              </div>
            </div>
          </div>
          <div className="error-box u-margin-top-small-1 u-width-95 u-margin-center-auto">
            {errors?.map((error: any, index: number) => {
              return (
                <p className="error-box__content" key={index}>
                  {error.message}
                </p>
              );
            })}
          </div>

          <div className="u-width-85 u-margin-center-auto u-margin-top-medium">
            {!isLoading ? (
              <button
                className="btn btn--primary medium"
                disabled={disableButton}
              >
                بررسی پلاک
              </button>
            ) : (
              <a href="/#" className="btn btn--primary medium">
                <DotLoading />
              </a>
            )}
          </div>
        </form>
      </div>

      {plaqueInfo.hasInfo && (
        <div className="u-margin-bottom-big-7 u-margin-top-small-3 u-width-100">
          <div className="profile-box">
            <div className="profile-box__table u-width-72">
              <div className="profile-box__table--row">
                <label>نوع وسیله نقلیه:</label>
                <span>{plaqueInfo.serviceType}</span>
              </div>
              <div className="profile-box__table--row">
                <label>وضعیت فعالیت:</label>
                <span
                  className={
                    plaqueInfo.carHealthStatus === ""
                      ? "u-grey"
                      : activityStatus[plaqueInfo.carHealthStatus].class
                  }
                >
                  {plaqueInfo.carHealthStatus === ""
                    ? "ثبت نشده"
                    : activityStatus[plaqueInfo.carHealthStatus].text}
                </span>
              </div>
              <div className="profile-box__table--row">
                <label>وضعیت کوید:</label>
                <span
                  className={
                    plaqueInfo.personHealthStatus === ""
                      ? "u-grey"
                      : status[plaqueInfo.personHealthStatus].class
                  }
                >
                  {plaqueInfo.personHealthStatus === ""
                    ? "ثبت نشده"
                    : status[plaqueInfo.personHealthStatus].text}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transportation;
